export const lockTypeConfig = {
  heading: "Zamki i dostęp",
  subtitle:
    "Jak gość dostaje się do obiektu? Dodaj jeden lub więcej zamków (wejście do budynku, jednostka…), każdy z własną nazwą i rodzajem dostępu.",
  loading: "Wczytywanie konfiguracji…",

  enable: {
    title: "Wysyłaj kody dostępu",
    sub:
      "Po wyłączeniu tej opcji nie będziemy wysyłać gościowi kodów dostępu. Instrukcje przyjazdu i tak zostaną wysłane, niezależnie od tego ustawienia.",
  },

  scope: {
    labelRoom: "Pokój do skonfigurowania",
    labelUnit: "Jednostka do skonfigurowania",
    hintRoom: "Każdy pokój ma własną konfigurację dostępu.",
    hintUnit: "Każda jednostka ma własną konfigurację dostępu.",
  },

  conflict: {
    title: "Te przestrzenie nie będą korzystać z tej konfiguracji",
    textBefore:
      "Zachowują własne kody, a przy wysyłce zawsze wygrywa konfiguracja bardziej szczegółowa.",
    textStrong: "Zmiany wprowadzone tutaj do nich nie dotrą",
    textAfter: "dopóki pozostają w tym stanie:",
    lockCount: "zamek | zamki | zamków",
    applying: "Stosowanie…",
    applyAll: "Zastosuj tę konfigurację do wszystkich",
  },

  lockBadge: "Zamek {n}",
  removeLock: "Usuń zamek",
  nameLabel: "Nazwa wejścia",
  namePlaceholder: "Albo wpisz nazwę…",
  typeLabel: "Rodzaj dostępu",
  codePlaceholderBox: "Kod skrytki na klucze · np. 5817",
  codePlaceholderLock: "Kod zamka · np. 5817",
  lockFallback: "Zamek",
  connectedSuffix: "podłączony",
  editConfig: "Edytuj konfigurację",
  configure: "Skonfiguruj…",
  addLock: "Dodaj kolejny zamek",
  roomsHint:
    "Każdy pokój ma własny zamek i kod. Skonfiguruj je tutaj, jeden po drugim.",

  wa: {
    online: "online",
    today: "Dzisiaj",
    captionOverriding: "Tak otrzymuje to {source} · nie przestrzenie wskazane powyżej",
    captionPreview: "Podgląd · tak otrzyma to gość · {source}",
  },

  modal: {
    title: "Skonfiguruj inteligentny zamek",
    sub: "Wybierz markę i podłącz ją, aby generować automatyczne kody dla każdej rezerwacji.",
    close: "Zamknij",
    note: "Najpierw dodaj jednostkę do oferty, aby skonfigurować inteligentny zamek.",
  },

  providerOther: "Inna marka",

  presets: {
    main: "Wejście główne",
    property: "Wejście do obiektu",
    unit: "Wejście do jednostki",
  },

  entryFallback: "Wejście",
  roomFallback: "Pokój",
  yourProperty: "Twój obiekt",

  types: {
    none: {
      title: "Skrytka na klucze",
      desc: "Skrytka zabezpieczająca z kluczami do obiektu.",
    },
    dynamic: {
      title: "Inteligentny zamek",
      desc: "Nowy automatyczny kod dla każdej rezerwacji.",
    },
    static: {
      title: "Zamek ze stałym kodem",
      desc: "Kod, który zmienia się ręcznie co jakiś czas.",
    },
  },

  source: {
    room: "ten pokój",
    unit: "ten obiekt",
    property: "ta oferta",
  },

  preview: {
    boxText:
      "🔑 *{label} · {name}*\n\nSkrytka na klucze otwiera się kodem: *{code}*\n\nW środku znajdują się klucze do obiektu. Prosimy o odłożenie ich tam przy wyjeździe.",
    dynamicText:
      "🔒🔑 *{label} · {name}*\n\nKod dostępu: *58117*\n\nWażny przez cały pobyt.",
    staticText:
      "🔒🔑 *{label} · {name}*\n\nKod do zamka: *{code}*\n\nOtwiera drzwi obiektu.",
  },

  summary: {
    dynamic: "Inteligentny zamek",
    codePrefix: "Kod {code}",
    staticCode: "Stały kod",
    boxPrefix: "Skrytka na klucze {code}",
    empty: "Nie skonfigurowano",
  },

  toast: {
    saved: "Dostęp zapisany",
    saveError: "Nie udało się zapisać metody dostępu.",
    unified: "Konfiguracja ujednolicona",
    unifyError: "Nie udało się ujednolicić konfiguracji.",
    savedRoom: "Dostęp zapisany · {room}",
    saveErrorRoom: "Nie udało się zapisać dostępu · {room}.",
    theRoom: "pokój",
  },
};
